import { render, staticRenderFns } from "./UrbanismRegulationsList.vue?vue&type=template&id=a24e9d6a&scoped=true&"
import script from "./UrbanismRegulationsList.vue?vue&type=script&lang=js&"
export * from "./UrbanismRegulationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e9d6a",
  null
  
)

export default component.exports